export * as Admin from './admin.response';
export * as AuditLog from './audit-log.response';
export { Auditable, Updatable } from './auditable';
export * as Calendar from './calendar.response';
export * as FiltersResponse from './filters.response';
export * as Firebase from './firebase.response';
export * as Notifications from './notifications.response';
export * as Sales from './sales.response';
export * as Scheduling from './scheduling.response';
export * as SiteManagement from './site-management.response';

export interface RowsAffected {
  rowsAffected: number;
}

export interface UpdateBody {
  message: string;
  rowsAffected: number;
  id: string;
}

export interface UpdateResponse {
  body: UpdateBody;
}
